import React, { FC } from 'react'
import { Text } from '@chakra-ui/react'
import { Trans } from '@lingui/macro'
import useOnlineStatus from '../../../public-api/hooks/useOnlineStatus'

const OfflinePopup: FC = () => {
  const onlineStatus = useOnlineStatus()

  return onlineStatus === false ? (
    <div className="modal-wrapper">
      <div className="modal-body modal-body-small modal-info offline">
        <div className="modal-content">
          <h3>
            <Trans>Offline</Trans>
          </h3>
          <Text mt={'16px'}>
            <Trans>
              You appear to be disconnected from the server. You won't be able
              to continue until the connection is restored.
            </Trans>
          </Text>
        </div>
      </div>
    </div>
  ) : null
}

export default OfflinePopup
